import type { MappedTuple, Tuple } from "@/interfaces/estimate-detail";
import type { Estimation } from "@/interfaces/estimation.interface";
import { useCallback, useState } from "react";
import type { Category } from "..";
import { Container } from "./Container";
import { TabContent } from "./TabContent";
import { Tabs } from "./Tabs";

interface LineItemsTabsProps {
  estimation?: Estimation;
  itemCategoryTab: Record<Category, MappedTuple[]>;
  pageId: string;
  tuples: Tuple[];
  estimateId?: string;
  onDelete?: (val: string, uniqueId: string, category?: Category) => void;
  onSelectItem?: (uniqueId: string, category?: Category) => void;
}

export const LineItemsTabs = ({ tuples, pageId, itemCategoryTab, onDelete, onSelectItem, estimation, estimateId }: LineItemsTabsProps) => {
  const [selectedTab, setSelectedTab] = useState<Category>();

  const onSelectTab = useCallback((tab: Category) => {
    setSelectedTab((prev) => {
      if (prev === tab) return undefined;

      return tab;
    });
  }, []);

  const availableCategories = (Object.keys(itemCategoryTab) as Category[]).filter((category) => itemCategoryTab[category].length > 0);

  if (availableCategories.length === 0) return null;

  return (
    <div className="flex w-full flex-col">
      <Container>
        <Tabs itemCategoryTab={itemCategoryTab} onSelectTab={onSelectTab} selectedTab={selectedTab} />
      </Container>
      <TabContent
        estimateId={estimateId}
        estimation={estimation}
        tuples={tuples}
        selectedTab={selectedTab}
        lines={selectedTab ? itemCategoryTab[selectedTab] : []}
        pageId={pageId}
        onDelete={onDelete}
        onSelectItem={onSelectItem}
      />
    </div>
  );
};
